/**
 * Application entry point. Mounts the React root and wraps the router in
 * the two app-wide providers: TanStack Query (server state) and React
 * Router. These contexts are assumed to exist by every feature below —
 * nothing else in the app should mount providers.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { createQueryClient } from '@/lib/api/queryClient';
import '@/index.css';

const queryClient = createQueryClient();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
